<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Add folder</template>
    <template #trailing>
      <Sheet.Button
        variant="primary"
        :icon="CheckmarkIcon"
        :disabled="loading || !canSave"
        @click="handleClick"
      />
    </template>

    <Sheet.Body class="pt-2">
      <Input
        v-model="name"
        size="xl"
        label="Folder name"
        :error="error"
        :disabled="loading"
        @keyup.enter="handleClick"
      />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, Input, useSheet } from '@dacr/library'
import { CloseIcon, CheckmarkIcon } from '@dacr/icons'
import { useAddFolder } from './useAddFolder'

const { close } = useSheet()

const props = defineProps<{
  folderId: string
  parentPath?: string
  handler?: (folder: { id: string; name: string }) => void
}>()

const { name, error, loading, canSave, handleClick } = useAddFolder(
  props,
  close
)
</script>
